import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/conditional-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/global-layout-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/header-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/header-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/marker-io.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthAndPermissionsProvider"] */ "/app/contexts/auth-and-permissions-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"display\":\"swap\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/sonner/dist/index.mjs");
